import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NoteService } from 'src/app/services/note.service';
import { CartService } from 'src/app/services/cart.service';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { INote } from 'src/app/intefaces/INote';
import { Subscription } from 'rxjs';
import { CurrencyService } from 'src/app/services/currency.service';
import { getCurrencySymbol } from '@angular/common';
import { Meta, MetaDefinition, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-note-page',
  templateUrl: './note-page.component.html',
  styleUrls: ['./note-page.component.scss']
})
export class NotePageComponent implements OnInit, OnDestroy {
  note: INote;
  noteId: number;
  isLoading = false;
  categoryName: string;
  recommendedNotes = [];
  playClicked = false;
  playSrc = '';
  fullScreenImageMode: boolean = false;
  previewUrl = environment.previewUrl;
  environmentUrl = environment.url;
  fbButtonUrl = `https://www.facebook.com/sharer/sharer.php?u=${environment.url}`;
  private currencySubscription: Subscription;
  public selectedCurrency: string;
  public currencySymbol: string;
  faFacebookF = faFacebookF;
  noteUrl;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private noteService: NoteService,
    private storageServie: BrowserStorageService,
    private currencyService: CurrencyService,
    private cartService: CartService,
    private title: Title, private translateService: TranslateService, private meta: Meta) {
    route.params.subscribe(params => {
      this.noteId = parseInt(params.id);
      if (!isNaN(this.noteId)) {
        this.ngOnInitRef();
      } else {
        this.router.navigate(['']);
      }
    });
  }

  ngOnInit(): void {
    this.getCurrency();
    this.currencySubscription = this.currencyService.
      currencyChangeEmitter.subscribe((name: string) => {
        this.getCurrency();
      });


  }

  ngOnDestroy(): void {
    this.currencySubscription.unsubscribe();
  }

  ngOnInitRef() {
    this.isLoading = true;
    this.noteService.getNoteById(this.noteId).subscribe(noteResponse => {
      if (noteResponse.success) {
        this.note = noteResponse.data;

        const obj = {
          category_note_id: this.note.categories[0].category_note_id,
          note_id: this.note.id
        }

        this.playAudio();

        this.noteService.getNotesByCategory(obj).subscribe(notesResponse => {
          if (noteResponse.success) {
            this.recommendedNotes = notesResponse.data.notesByCategory.data;
            this.categoryName = notesResponse.data.categoryName;
          }
        });

        this.noteUrl = environment.url + "/note/" + this.note.id + "/" + this.note.slug;
        this.fbButtonUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.noteUrl}`;
        const tags: MetaDefinition[] = [
          {
            content: this.noteUrl,
            property: "og:url"
          },
          {
            content: 'website',
            property: "og:type"
          },
          {
            content: this.note.title,
            property: "og:title"
          },
          {
            content: this.note.description,
            property: "og:description"
          },
          {
            content: this.note.description,
            name: "description"
          }
        ];

        this.title.setTitle("Nuty.eu - " + this.note.title);
        this.meta.addTags(tags);
      }
      this.isLoading = false;
    });
  }

  public getCurrency() {
    setTimeout(() => {
      this.selectedCurrency = this.storageServie.get("_currency");
      this.currencySymbol = getCurrencySymbol(this.selectedCurrency, "narrow");
    }, 100);
  }

  public playAudio() {
    this.playSrc = `${environment.soundUrl}/${this.note.sample_audio}`;
    this.playClicked = true;
  }

  public addToCart() {
    this.cartService.addToCart(this.note);
  }

  public handleShowFullScreenImage() {
    const windowRef = this.storageServie.windowReference();
    if (windowRef.innerWidth > 576) {
      this.fullScreenImageMode = true;
    }
  }

  public closeFullScreenImage() {
    this.fullScreenImageMode = false;
  }

  public handleReloadNote() {
    this.ngOnInitRef();
  }

}
